(() => {
  const DELAY_CLOSE = 1500;
  const closeTimers = new Set();

  function scheduleClose() {
    const t = setTimeout(() => {
      closeTimers.delete(t);
      closeAllDropdowns();
    }, DELAY_CLOSE);
    closeTimers.add(t);
  }

  function cancelClose() {
    closeTimers.forEach(t => clearTimeout(t));
    closeTimers.clear();
  }

  function getDropdown(handle) {
    const all = document.querySelectorAll('#wth-mega-' + handle);
    return all[all.length - 1] || null;
  }

  function openDropdown(handle) {
    cancelClose();
    closeAllDropdowns();
    const el = getDropdown(handle);
    if (el) el.classList.add('is-open');
  }

  function closeAllDropdowns() {
    document.querySelectorAll('.wth-mega-wrap').forEach(el => {
      el.classList.remove('is-open');
    });
  }

  function hideHorizonSubmenu(linkEl) {
    const listItem = linkEl.closest('li, .menu-list__list-item');
    if (!listItem) return;
    const submenus = listItem.querySelectorAll(
      '.menu-list__submenu, [ref="submenu[]"], .header-menu__submenu, .mega-menu'
    );
    submenus.forEach(submenu => {
      submenu.style.setProperty('display',     'none',   'important');
      submenu.style.setProperty('visibility',  'hidden', 'important');
      submenu.style.setProperty('opacity',     '0',      'important');
      submenu.style.setProperty('height',      '0',      'important');
      submenu.style.setProperty('overflow',    'hidden', 'important');
      submenu.setAttribute('aria-hidden', 'true');
    });
  }

  function attachListeners() {
    const allLinks = Array.from(document.querySelectorAll('.menu-list__link'));

    allLinks.forEach(link => hideHorizonSubmenu(link));
    setTimeout(() => allLinks.forEach(link => hideHorizonSubmenu(link)), 800);
    setTimeout(() => allLinks.forEach(link => hideHorizonSubmenu(link)), 1500);

    const megaHandles = [
      { handle: 'solutions', match: el => (el.getAttribute('href') || '').includes('solutions') || el.textContent.trim().toLowerCase() === 'solutions' },
      { handle: 'catalog',   match: el => (el.getAttribute('href') || '').includes('catalog')   || el.textContent.trim().toLowerCase() === 'catalog' },
      { handle: 'brands',    match: el => (el.getAttribute('href') || '').includes('brands')    || el.textContent.trim().toLowerCase() === 'brands' }
    ];

    megaHandles.forEach(({ handle, match }) => {
      const link = allLinks.find(match);
      if (!link) { console.warn('[WTH] nav link not found:', handle); return; }

      link.addEventListener('pointerenter', () => openDropdown(handle));

      const listItem = link.closest('li, .menu-list__list-item');
      if (listItem) {
        listItem.addEventListener('pointerleave', (e) => {
          if (e.relatedTarget && e.relatedTarget.closest('.wth-mega-wrap')) return;
          scheduleClose();
        });
      }
    });

    document.querySelectorAll('.wth-mega-wrap').forEach(dropdown => {
      dropdown.addEventListener('pointerenter', cancelClose);
      dropdown.addEventListener('pointerleave', (e) => {
        if (e.relatedTarget && e.relatedTarget.closest('.wth-mega-wrap')) return;
        scheduleClose();
      });
    });

    allLinks.forEach(link => {
      const href = link.getAttribute('href') || '';
      const text = link.textContent.trim().toLowerCase();
      const isMega = href.includes('catalog') || href.includes('brands') || href.includes('solutions') ||
                     text === 'catalog' || text === 'brands' || text === 'solutions';
      if (!isMega) {
        link.addEventListener('pointerenter', scheduleClose);
      }
    });

    const headerEl = document.querySelector('header-component, header');
    if (headerEl) headerEl.addEventListener('pointerenter', cancelClose);

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.wth-mega-wrap') && !e.target.closest('.menu-list__link')) {
        closeAllDropdowns();
      }
    });
  }

  function init() {
    if (document.querySelector('.menu-list__link')) {
      attachListeners();
    } else {
      const observer = new MutationObserver(() => {
        if (document.querySelector('.menu-list__link')) {
          observer.disconnect();
          attachListeners();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(init, 300));
  } else {
    setTimeout(init, 300);
  }
})();
